import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Actions as EMPLOYEEACTIONS } from "../../../../store/actions/employeeActions";
import "react-datepicker/dist/react-datepicker.css";
import { format, addMonths } from "date-fns";
import {
	ArrowDownTrayIcon,
	ArrowLeftIcon,
	ArrowRightIcon,
	ArrowUpTrayIcon, BellAlertIcon,
	CheckIcon, ForwardIcon,
	XMarkIcon
} from "@heroicons/react/20/solid";
import ImportEmployeeRow from "./ImportEmployeeRow";
import { CSVLink } from "react-csv";
import Spinner from "../../../common/Spinner";
import ImportedEmployeeRow from "./ImportedEmployeeRow";
import { FileUploader } from "react-drag-drop-files";
import { Cog8ToothIcon, DocumentArrowUpIcon } from "@/icons/solid";
import Tooltip from "@/tooltip";
import BuddySelector from "buddy/selector";

const ImportFieldColumn = ({
	// headers,
	fields,
	// sampleRows,
	innerMapping,
    updateFieldMapping,
    updateInnerFieldMapping,
    column,
    index,
    sample,

    importType,
    field,
    validPercentage,
    invalidPercentage,
    blankPercentage,
    percentage,
    totalRows,
    totalMappings,
    innerMappingForField,
}) => {
    return (
        <>
          <tr key={index}>
              <td>{column?.header}</td>
              <td>
                  <BuddySelector
                      options={fields}
                      isClearable={true}
                      value={field && {
                          label: field?.name,
                          value: field?.field,
                          group: field?.groupName
                      }}
                      onChange={(value) => {
                          updateFieldMapping({header: column.header, value, importType})
                          // const newFields = fields.map((field) => {
                          // 	if (field.header === header.header) {
                          // 		field.matchedField = fields.find((field) => field.name === value);
                          // 	}
                          // 	return field;
                          // });
                          // setFields(newFields);
                      }}
                  />
              </td>
              <td>{
                      sample && field?.type === "date" && !isNaN(new Date(sample)) ?
                      format(new Date(sample), "dd/MM/yyyy") :
                      sample
                  }
              </td>
              <td>
                  {
                      field ? (
                          <div>
                              <CheckIcon className="text-green-500 w-7 h-7" />
                              Field Mapped
                          </div>
                      ) : (
                          <div>
                              <ForwardIcon className="text-blue-500 w-7 h-7" />
                              Skip this field
                          </div>
                      )
                  }
                  {/*{totalRows}*/}
                  {/*{JSON.stringify(column?.validation)}*/}
                  {field && totalRows > 0 && (
                      column?.validation && validPercentage == 100 ? (
                          <div>
                              <CheckIcon className="text-green-500 w-7 h-7" />
                              100% Valid
                          </div>
                      ) : (
                          <div>
                              <BellAlertIcon className="text-red-500 w-7 h-7" />
                              {invalidPercentage.toFixed(0)}% Invalid and {blankPercentage.toFixed(0)}% Blank
                          </div>
                      )
                  )}

                  { field && totalMappings > 0 && (
                      <div>
                          {/* Show check if 100% mapped else a warning */}
                          {percentage == 100 ? (
                              <CheckIcon className="text-green-500 w-7 h-7" />
                          ) : (
                              <XMarkIcon className="text-red-500 w-7 h-7" />
                          )}
                          {percentage.toFixed(0)}% Options Match
                      </div>
                  )}
              </td>
          </tr>
          {
            field && totalMappings > 0 && (
                Object.keys(innerMappingForField).map((key, index) => {
                    const value = innerMappingForField[key];
                    console.log('value',value)
                    return (
                        <tr key={key}>
                            <td>{index === 0 ? `↳ Options`: ``}</td>
                            <td>{key}</td>
                            <td colSpan={2}>
                              <BuddySelector
                                options={field?.options ?? []}
                                isClearable={true}
                                value={value?.item}
                                onChange={(item) => {
                                    updateInnerFieldMapping({header: column.header, key, item})
                                }}
                              />
                            </td>
                        </tr>
                    );
                })
            )
          }
        </>
    );
};

const mapStateToProps = (state, ownProps) => {

	const {headers, fields, sampleRows, innerMapping, /*sampleRow*/} = state.employees.uploadMapping;


	const selectableFields = fields.map(group => {
		return {
			label: group.name,
			options: group.options.map(option => {
				return {
					label: option.name,
					value: option.field,
					group: group.name,
                    innerOptions: option.options?.map(innerOption => {
                        return {
                            label: innerOption.label,
                            value: innerOption.value,
                        }
                    }),
				};
			}),
		}
	})

    const index = ownProps.index;
    const sampleRow = ownProps.sampleRow;

    const sample = sampleRows[sampleRow ?? 0][index];

    const column = headers[index];

    const field = column?.matchedField

    const totalRows = (column?.validation?.blank ?? 0) + (column?.validation?.invalid ?? 0) + (column?.validation?.valid ?? 0);
    const validPercentage = (column?.validation?.valid ?? 0) / totalRows * 100;
    const invalidPercentage = (column?.validation?.invalid ?? 0) / totalRows * 100;
    const blankPercentage = (column?.validation?.blank ?? 0) / totalRows * 100;

    const innerMappingForField = innerMapping[column?.header];
    const totalMappings = innerMappingForField ? Object.keys(innerMappingForField).length : 0;
    const matchedMappings = innerMappingForField ? Object.values(innerMappingForField).filter((value) => value).length : 0;
    const percentage = totalMappings > 0 ? matchedMappings / totalMappings * 100 : 0;


	return {
		// headers,
		fields: selectableFields,
		// sampleRows,
		innerMapping,
        sample,
		jurisdiction: state.company?.settings?.jurisdiction,

        column,
        innerMappingForField,
        field,
        validPercentage,
        invalidPercentage,
        blankPercentage,
        percentage,
        totalRows,
        totalMappings,
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(EMPLOYEEACTIONS.toggleImportModal()),
    updateFieldMapping: (input) => dispatch(EMPLOYEEACTIONS.employeeUpdateFieldMapping(input)),
    updateInnerFieldMapping: (input) => dispatch(EMPLOYEEACTIONS.employeeUpdateInnerMapping(input)),
	uploadFile: (file, agreement) => dispatch(EMPLOYEEACTIONS.uploadFile({ file, agreement })),
	employeesGetListWithSalary: () =>
		dispatch(
			EMPLOYEEACTIONS.employeesGetListWithSalary({
				from: format(addMonths(new Date(), -2), "yyyy-MM-01"), // get list from last 2 months
				to: format(new Date(), "yyyy-12-31"),
			}),
		),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportFieldColumn);
